import Skeleton from 'react-loading-skeleton';

type BeatEcgViewerSkeletonProps = {
  noData?: boolean;
};

const BeatEcgViewerSkeleton = ({ noData }: BeatEcgViewerSkeletonProps) =>
  noData ? (
    <div id="ecg-viewer" className="ecg-viewer-container">
      <div className="ecg-viewer-skeleton-container">
        <div style={{ height: 294 }} className="chart-container">
          <div className="no-data">There is no ECG data to display.</div>
        </div>
      </div>
    </div>
  ) : (
    <div id="ecg-viewer" className="ecg-viewer-container">
      <div className="navigator-container">
        <Skeleton height={22} width={945} />
      </div>
      <div className="ecg-viewer-skeleton-container">
        <div className="chart-container">
          <Skeleton height="100%" />
        </div>
        <div className="menu-container">
          <Skeleton height="100%" />
        </div>
      </div>
    </div>
  );

export default BeatEcgViewerSkeleton;
